export default __webpack_public_path__ + "static/media/Fire Station.e3fbe001.svg";